import {
    InstanceFactory,
    KendraConst,
    SHARED_CATEGORY_ATTRIBUTE_VALUE
} from "@amzn/ask-legal-domain";
import { QueryResultItem } from "@aws-sdk/client-kendra";

export const getInstanceIdFromResult = (resultItem: QueryResultItem): string | null => {
    const instanceIdAttribute = resultItem.DocumentAttributes?.find(attr =>
        attr.Key === KendraConst.ContainerIngestionKendraAttributes.Default.InstanceId
    );
    if (instanceIdAttribute?.Value?.StringValue) {
        return instanceIdAttribute.Value.StringValue;
    }

    const pageIdAttribute = resultItem.DocumentAttributes?.find(attr =>
        attr.Key === KendraConst.ContainerIngestionKendraAttributes.Custom.PageId
    );
    if (pageIdAttribute?.Value?.StringValue) {
        return InstanceFactory.fromEntityId(pageIdAttribute.Value.StringValue);
    }

    return null;
};

export const getSearchResultDocumentUrl = (props: {
    resultItem: QueryResultItem;
    instanceId: string;
    sharedPageLibrariesEnabled?: boolean;
}): string => {
    let documentUrl = props.resultItem.DocumentURI;

    // Skip shared-page URL rewriting when SharedPL feature is disabled
    if (props.sharedPageLibrariesEnabled === false) {
        return documentUrl;
    }

    const sharedDocumentAttribute = props.resultItem.DocumentAttributes.find(
        attr => attr.Key === KendraConst.ContainerIngestionKendraAttributes.Custom.AdditionalCategories
    )?.Value?.StringValue;
    if (!sharedDocumentAttribute || sharedDocumentAttribute !== SHARED_CATEGORY_ATTRIBUTE_VALUE) {
        return documentUrl;
    }

    const documentPageId = props.resultItem.DocumentAttributes.find(
        attr => attr.Key === KendraConst.ContainerIngestionKendraAttributes.Custom.PageId
    )?.Value?.StringValue;
    if (!documentPageId) {
        return documentUrl;
    }

    const documentInstanceId = getInstanceIdFromResult(props.resultItem);
    let currentInstanceId = props.instanceId;
    if (documentInstanceId === currentInstanceId) {
        return documentUrl;
    }

    documentUrl = getSharedPageUrl({
        pageId: documentPageId,
        instanceId: currentInstanceId
    });
    return documentUrl;
};

export const getSharedPageUrl = (props: {
    pageId: string;
    instanceId: string;
}): string => {
    return `${window.location.origin}#/shared-page/${props.instanceId}/${props.pageId}/live`;
};
